module.exports = __webpack_public_path__ + "media/images/vp/logo.white-56df986e81120a1b1e1065a676f7f6bf.svg";